import { ContentLoader } from '@moovly/ui';
import * as React from 'react';
import { TableCol, TableRow } from './Table';

interface TableLoaderProps {
  columnns?: number;
  rows?: number;
  cellWidth?: number | string;
}

const TableLoader: React.FC<TableLoaderProps> = ({ columnns = 1, rows = 1, cellWidth }) => (
  <>
    {Array.from(Array(rows), (_, i) => (
      <TableRow key={`table-loader-row-${i}`}>
        {Array.from(Array(columnns), (_, j) => (
          <TableCol key={`table-loader-column-${i}-${j}`}>
            <ContentLoader width={cellWidth} />
          </TableCol>
        ))}
      </TableRow>
    ))}
  </>
);

export default TableLoader;
